import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ListingPermission from './ListingPermission';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';


export default async function action({ store, intl, query }) {

  const listingType = query && query.type === 'experience' ? 'experience' : 'accommodation';
  const title = listingType === 'experience' ? 'Aprobaciones de experiencias' : 'Aprobaciones de alojamiento';

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
  if (!restrictUrls('/siteadmin/listing-request', adminPrivileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><ListingPermission key={listingType} listingType={listingType} title={title} /></AdminLayout>,
  };
}
